/* import __COLOCATED_TEMPLATE__ from './select-list.hbs'; */
var _dec, _dec2, _dec3, _dec4, _dec5, _class, _descriptor;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Component from '@ember/component';
import { computed } from '@ember/object';
import { ExternalBankAccount } from '@square/dashboard-protos/models/squareup/sfs/external/models/external_bank_account';
import { inject as service } from '@ember/service';
import { Account } from '@square/dashboard-protos/models/squareup/banking/account_model';
import { OwnerType, AccountType, AccountState } from '@square/dashboard-protos/models/squareup/banking/common';
let SelectList = (_dec = computed('accountOptions.length'), _dec2 = computed('accountOptions'), _dec3 = computed('balances'), _dec4 = computed('balances.length'), _dec5 = computed('locationSelector.units', 'balances'), _class = class SelectList extends Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "tagName", '');
    _defineProperty(this, "accountOptions", void 0);
    _initializerDefineProperty(this, "locationSelector", _descriptor, this);
  }
  get balances() {
    const array = [];
    this.accountOptions.forEach(({
      account,
      id
    }) => {
      if (account instanceof Account) {
        array.push({
          id,
          account
        });
      }
    });
    return array;
  }
  get externalBankAccounts() {
    const array = [];
    this.accountOptions.forEach(option => {
      if (option.account instanceof ExternalBankAccount) {
        array.push(option);
      }
    });
    return array;
  }
  get savingsAccounts() {
    const array = [];
    this.balances.forEach(option => {
      if (option.account.type === AccountType.SAVINGS_ACCOUNT && option.account.state !== AccountState.CLOSED) {
        array.push(option);
      }
    });
    return array;
  }
  get foldersAccounts() {
    const array = [];
    this.balances.forEach(option => {
      if (option.account.type === AccountType.FOLDERS_ACCOUNT && option.account.state !== AccountState.CLOSED) {
        array.push(option);
      }
    });
    return array;
  }
  get locationAccounts() {
    if (!this.balances) {
      return [];
    }
    return this.balances.filter(({
      account
    }) => {
      if (account && account.owner) {
        return account.owner.type === OwnerType.UNIT && account.type !== AccountType.SAVINGS_ACCOUNT && account.type !== AccountType.CLEARING_ACCOUNT;
      } else {
        return false;
      }
    }).map(({
      account,
      id
    }) => {
      if (account && account.owner) {
        const unit = this.locationSelector.units.find(unit => {
          if (account && account.owner) {
            return unit.token === account.owner.id;
          } else {
            return false;
          }
        });
        if (!unit) {
          return null;
        }
        return {
          id,
          account: {
            availableBalance: account.availableBalance,
            unitNickname: unit.nickname,
            balanceType: account.type
          }
        };
      } else {
        return null;
      }
    });
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "locationSelector", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "balances", [_dec], Object.getOwnPropertyDescriptor(_class.prototype, "balances"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "externalBankAccounts", [_dec2], Object.getOwnPropertyDescriptor(_class.prototype, "externalBankAccounts"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "savingsAccounts", [_dec3], Object.getOwnPropertyDescriptor(_class.prototype, "savingsAccounts"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "foldersAccounts", [_dec4], Object.getOwnPropertyDescriptor(_class.prototype, "foldersAccounts"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "locationAccounts", [_dec5], Object.getOwnPropertyDescriptor(_class.prototype, "locationAccounts"), _class.prototype), _class);
export { SelectList as default };